import React from 'react';
import Paper from '@material-ui/core/Paper';
import { t } from 'ttag';
import useReactRouter from 'use-react-router';
import { MTableToolbar } from 'material-table';
import KeyboardBackspaceIcon from '@material-ui/icons/KeyboardBackspace';
import { useMutation } from '@apollo/react-hooks';
import { Tooltip } from '@material-ui/core';
import IconButton from '@material-ui/core/IconButton';
import DataTable from '../../../components/DataTable';
import useApi from '../../../api';
import useDataList from '../../../hooks/useDataList';
import useUser from '../../../auth/hooks';
import { formatRank } from '../../../utils/helpers';
import { useNavigator } from '../../../components/Navigator';
import router from '../../../api/router';
import useEditForm from '../../../hooks/useEditForm';
import { RANK_PRIORITY_MAP, STATUS_PROTOCOL_TITLE } from '../../../utils/enums';
import Loading from '../../../components/Loading';

const Protocol = () => {
  const navigate = useNavigator();
  const { match } = useReactRouter();
  const certificationsId = match.params.id;
  const api = useApi();
  const { user } = useUser();
  const [processLoading, setLoading] = React.useState(false);
  const { data, loading } = useDataList({
    schema: api.schema.protocols,
    router: null,
    variables: { inputFilter: { certificationsId: Number(certificationsId) } },
  });
  useEditForm({
    schema: api.schema.certifications,
    router: null,
    variables: { inputFilter: { id: Number(certificationsId) } },
  });
  const [generateProfileInfo] = useMutation(
    api.schema.certifications_athlete.generateProfileInfo()[0],
    {
      onCompleted: (d) => {
        setLoading(false);
        const res =
          d[api.schema.certifications_athlete.generateProfileInfo()[1]];
        if (res.ok) {
          window.open(res.url, '_blank').focus();
        }
      },
    }
  );
  const columns = [
    { title: t`Id`, field: 'protocolId', editable: 'never' },
    {
      title: t`Кю`,
      field: 'rank',
      render: ({ rank }) => formatRank(rank) || '',
      customSort: (a, b) =>
        (RANK_PRIORITY_MAP[a.rank] || 0) - (RANK_PRIORITY_MAP[b.rank] || 0),
    },
    { title: t`Спортсменів`, field: 'countAthletes' },
    {
      title: t`Статус`,
      field: 'status',
      render: ({ statusProtocol }) => STATUS_PROTOCOL_TITLE[statusProtocol],
    },
  ];

  const handleGenPdf = (e, rowData) => {
    setLoading(true);
    generateProfileInfo({
      variables: {
        id: certificationsId,
        rank: rowData.rank,
        protocolId: rowData.protocolId,
      },
    });
  };

  if (loading) return <Loading />;

  return (
    <Paper>
      <DataTable
        isLoading={loading}
        processLoading={processLoading}
        title='Протоколи'
        columns={columns}
        data={data || []}
        components={{
          Toolbar: (props) => (
            <div>
              <MTableToolbar {...props} />
              <div style={{ padding: '0px 10px' }}>
                <Tooltip title='Повернутись до загального списку екзамену'>
                  <IconButton
                    aria-label='delete'
                    onClick={
                      user.isAdmin
                        ? () =>
                            navigate(
                              router.admin.certifications.athleteList(
                                certificationsId
                              )
                            )
                        : () =>
                            navigate(
                              router.cabinet.certifications.athleteList(
                                certificationsId
                              )
                            )
                    }
                  >
                    <KeyboardBackspaceIcon />
                  </IconButton>
                </Tooltip>
              </div>
            </div>
          ),
        }}
        // onEdit={(e, d) => navigate(api.router.certifications.editAthlete(certificationsId, d.id))}
        onViewAthlete={(event, rowData) =>
          navigate(
            api.router.certifications.ListAthleteProt(
              certificationsId,
              rowData.rank,
              rowData.protocolId
            )
          )
        }
        // onDelete={isIntersection(user.types, [USER_TYPES.trainer]) && (dataCert ? dataCert.status : null) == 2 ? null
        //  : (d) => (d.statusProtocol === 2 ? null : onDeleteProtocol(d))}
        onGenerateRowPdf={handleGenPdf}
      />
    </Paper>
  );
};

export default Protocol;
